import api from "../api";

// تابعی برای دریافت لیست سفارشات (با فیلترها)
export const getOrders = async (tab, search, page = 1, limit = 10) => {
  const params = {
    tab,
    page,
    page_size: limit,
  };

  if (search) {
    params.search = search;
  }

  const response = await api.get('operation/customer/orders/', {
    params,
  });

  return response.data;
};


// تابعی برای دریافت جزئیات یک سفارش خاص (برای آکاردئون)
export const getOrderDetail = async (orderId) => {
  const response = await api.get(`operation/customer/orders/${orderId}/`);
  return response.data;
};

// تابعی برای دریافت اطلاعات نظر مشتری یک سفارش خاص (برای آکاردئون)
export const getOrderReviewable = async (orderId) => {
  const response = await api.get(`information/customer/orders/${orderId}/reviewables/`);
  return response.data;
};




